export default __webpack_public_path__ + "static/media/gcoeara1.e3fdb483.png";